import styled from "styled-components";

export const SubjectLogo = styled.img`
  height:30px;
`